import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { JornalService } from 'src/app/services/jornal.service';
import { obterEdicaoPorId, obterEdicaoPorIdFailure, obterEdicaoPorIdSuccess } from '../../actions/Jornal/obter-edicao-por-id.action';

@Injectable()
export class ObterEdicaoPorIdEffects {

  public obterEdicaoPorId$: unknown;

  constructor(private actions$: Actions,
    private jornalService: JornalService) {
    this.createEffects()
  }

  private createEffects() {
    this.obterEdicaoPorId$ = createEffect(() => this.actions$.pipe(
      ofType(obterEdicaoPorId),
      switchMap(({ inputDto, pagina }) =>
        this.jornalService
          .ObterEdicaoPorId(inputDto, pagina)
          .pipe(
            map(
              response => {
                if (response.erros != undefined && response.erros.length > 0) {
                  return obterEdicaoPorIdFailure({ response })
                }
                return obterEdicaoPorIdSuccess({ response })
              }),
            catchError(() => {
              return of()
            }
            )
          )
      )
    )
    );
  }
}
